import styled from 'styled-components'

export const LoadingCSS = styled.div`
  background-color: rgba(255, 255, 255, 0.6);
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;

  & > img {
    margin: auto;
  }

  & > span {
    position: fixed !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50px !important;
    height: 50px !important;
  }

  &.form-login {
    position: relative;
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
    align-items: center;
    justify-content: center;
    min-height: 400px;
    background-color: transparent;

    & > span {
      position: static !important;
      top: auto !important;
      left: auto !important;
      transform: none !important;
      margin: 0;
    }

    @media only screen and (max-width: 1023px) {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100dvw;
      height: 100dvh;
      min-height: 100dvh;
      background-color: rgba(255, 255, 255, 0.6);
      z-index: 10000;
    }
  }
`
